// extracted by mini-css-extract-plugin
export default {"root":"WW82w2jtG58ujqU5Tenk","tabs":"ievKeP4pfTfWqdYW3OQI","content":"lzxnbgI23nrDr7HXVUPC","btn":"M7OQAyvF18_DB40UvXBg","btnActive":"YcTD8Ajsc1ieZ00E0PVw"};